import { IFatura } from './../interfaces/ifatura';
import { IFaturaLista } from '../interfaces/ifatura-lista';
import { Convert } from './convert';

export class Fatura {
  static monthNames: string[] = [
    'Janeiro',
    'Fevereiro',
    'Março',
    'Abril',
    'Maio',
    'Junho',
    'Julho',
    'Agosto',
    'Setembro',
    'Outubro',
    'Novembro',
    'Dezembro',
  ];

  static categoryAcessoListagem: string = 'ACESSOLISTAGEM';
  static categoryAcessoFatura: string = 'ACESSOFATURA';
  static categoryAcessoPortalNegociacaoFatura: string = 'ACESSOPORTALNEGOCIACAOFATURA';
  static categoryAcessoEscolhaPagamento: string = 'ACESSOESCOLHAPAGAMENTO'
  static categoryAcessoPix: string = 'ACESSOPIX'
  static categoryCopyPix: string = 'COPYPIX'

  static currentMonth: string = '';
  static header: string = '';

  public static hasFaturas(faturas: IFaturaLista[]): boolean {
    return faturas && faturas.length ? true : false;
  }

  public static prepareFaturasSortedAndAsFaturaLista(faturas: IFatura[]): IFaturaLista[] {
    let orderedFaturas: IFatura[] = this.sortFaturasByDate(faturas);
    return this.treatFaturasAsFaturasLista(orderedFaturas);
  }

  public static treatFaturasAsFaturasLista(faturas: IFatura[]): IFaturaLista[] {
    let faturaLista: IFaturaLista[] = [];
    faturas.forEach((fatura) => {
      this.checkMonthHeader(fatura.dueDate);
      let index: number = faturaLista.findIndex((f) => {
        return f.header == this.currentMonth;
      });
      if (index >= 0) {
        faturaLista[index].faturas.push(fatura);
      } else {
        faturaLista.push({
          header: this.currentMonth,
          faturas: [fatura],
        });
      }
    });
    return faturaLista;
  }

  public static sortFaturasByDate(faturas: IFatura[]): IFatura[] {
    return faturas
      ? faturas.sort((a, b) => (a.dueDate > b.dueDate ? 1 : -1))
      : [];
  }

  public static isOverDue(dateFatura: string): boolean {
    return this.isDateOverDue(Convert.treatDateJSON(dateFatura));
  }

  public static isDateOverDue(date: Date): boolean {
    let now = Convert.newDateZeroes();
    return date < now;
  }

  public static isDateOverDueMoreThanAnyDays(
    dateFatura: string,
    days: number
  ): boolean {
    if (!this.isOverDue(dateFatura)) return false;
    return (
      this.dateDifferenceInDaysByNow(Convert.treatDateJSON(dateFatura)) > days
    );
  }

  public static dateDifferenceInDaysByNow(date: Date): Number {
    let now = Convert.newDateZeroes();
    let milliseconds: number = now.getTime() - date.getTime();
    return Math.ceil(milliseconds / 1000 / 60 / 60 / 24);
  }

  public static checkMonthHeader(dateFatura: string): string {
    let date: Date = Convert.treatDateJSON(dateFatura);
    if (this.isDateOverDue(date)) {
      this.header = 'Atrasado(s)';
    } else {
      this.header = this.monthNames[date.getMonth()];
    }
    if (this.header != this.currentMonth) {
      this.currentMonth = this.header;
    } else {
      this.header = '';
    }
    return this.header;
  }
}
